import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";

export enum StorageKeys {
  JWT = "token",
  USER_ID = "userId",
  CLIENT_ID = "clientId",
  APP_ID = "appId",
  LANGUAGE = "i18nextLng",
}

class SecureStorageService {
  set<T>(key: StorageKeys, value: T): void {
    try {
      if (key === StorageKeys.LANGUAGE) {
        localStorage.setItem(key, String(value));
      } else {
        localStorageSecureWrapper.setItem(key, value);
      }
    } catch (error) {
      console.error(`Error saving to secure storage: ${key}`, error);
    }
  }

  get<T>(key: StorageKeys): T | null {
    try {
      if (key === StorageKeys.LANGUAGE) {
        return localStorage.getItem(key) as T;
      } else {
        return localStorageSecureWrapper.getItem(key) as T;
      }
    } catch (error) {
      console.error(`Error reading from secure storage: ${key}`, error);
      return null;
    }
  }

  remove(key: StorageKeys): void {
    try {
      if (key === StorageKeys.LANGUAGE) {
        localStorage.removeItem(key);
      } else {
        localStorageSecureWrapper.removeItem(key);
      }
    } catch (error) {
      console.error(`Error removing from secure storage: ${key}`, error);
    }
  }

  clear(): void {
    try {
      localStorageSecureWrapper.clear();
      localStorage.removeItem(StorageKeys.LANGUAGE);
    } catch (error) {
      console.error("Error clearing secure storage", error);
    }
  }

  setMultiple(items: Partial<Record<StorageKeys, any>>): void {
    Object.entries(items).forEach(([key, value]) => {
      this.set(key as StorageKeys, value);
    });
  }

  getMultiple(keys: StorageKeys[]): Record<StorageKeys, any> {
    return keys.reduce(
      (acc, key) => {
        acc[key] = this.get(key);
        return acc;
      },
      {} as Record<StorageKeys, any>,
    );
  }
}

export const secureStorage = new SecureStorageService();